import { dispatch } from '../../store';
import {
  AuditLog,
  FavoriteProjectsResponse,
  PaginationResponse,
  RecommendationPagination,
  TCarbonProjectData,
  TRecommendation,
  TRecommendedProjectData,
  TSuggestions,
} from '../../types';
import {
  loadFiltersValues,
  loadProjectsSpecific,
  // setCurrentSkippedItems,
  setRecommendationPagination,
} from '../../store/projects/actions';

import { api, cookies } from '../../api';
import { changeUserAuditLogAction } from '../../store/users/actions';
import { convertDateString } from '../../utils/convertDateString';

export const fetchLogout = () => {
  const access_token = cookies.get('ciid_access_token');
  return api.get(`/user/logout`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};

export const fetchFilters = async () => {
  const access_token = cookies.get('ciid_access_token');
  dispatch(loadFiltersValues.submit());
  const { data } = await api.get(`/filters/`, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

  dispatch(loadFiltersValues.success(data));
};

export const fetchFavouriteProjects = async (params?: any) => {
  try {
    // if (params) {

    // }
    () => params;
    const response = await api.get(`/saved`, {
      params,
    });

    const savedProjects: TCarbonProjectData[] = response.data.items;

    if (response) {
      dispatch(
        loadProjectsSpecific.success({
          favorite: {
            items: savedProjects,
            total: response.data.total,
          } as any,
        }),
      );
    }

    // dispatch(setCoordinates(coordinatesArray));
    // dispatch(setCarbonData(carbonProjectDataArray));

    return savedProjects;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(loadProjectsSpecific.fail('Results not found'));
      return;
    }
    console.error('Error in:', error);
  }
};

export const fetchCurrentProjects = async (suggestions: any, params?: any) => {
  try {
    let body: any = { ...params };
    if (suggestions && suggestions.suggestions.length !== 0) {
      const { id, level } = suggestions.suggestions[0];
      body = { ...body, id, level };
    }

    if (params && params.locations) {
      const coordinates = Object.values(params.locations).map((item: any) =>
        item.map(({ lat, lng }: any) => [`${lng}`, `${lat}`]),
      );
      body.coordinates = coordinates;
    }

    const response = await api.post(`/projects/carbon`, body);

    const carbonProjectDataArray: TCarbonProjectData[] = [];

    if (response) {
      const carbonProjectData = response.data.items.features;
      carbonProjectDataArray.push(...carbonProjectData);
    }

    if (response) {
      dispatch(
        loadProjectsSpecific.success({
          carbon: {
            items: carbonProjectDataArray,
            pagination: response.data.pagination || {
              total: 0,
            },
            total: response.data.total,
          } as any,
        }),
      );
    }

    // dispatch(setCoordinates(coordinatesArray));
    // dispatch(setCarbonData(carbonProjectDataArray));

    return carbonProjectDataArray;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(loadProjectsSpecific.fail('Results not found'));
      return;
    }
    console.error('Error in:', error);
  }
};
export const fetchForestationProjects = async ({ skip = 0, limit = 20, search = null }) => {
  const { data } = await api.get(`/v2/recommendations/forestation`, {
    params: {
      skip,
      limit,
      search,
    },
  });
  console.log('Forestation projects fetched:', data);
  dispatch(
    loadProjectsSpecific.success({
      forestation: {
        items: data.items,
        total: data.total,
      } as any,
    }),
  );
};

export const fetchMangroveProjects = async (
  location: any,
  filterProps: any,
  recommendationPagination: RecommendationPagination,
) => {
  const ITEMS_PER_PAGE = 15;
  const recommendationProjectDataArray: TRecommendedProjectData[] = [];
  const currentPage = filterProps?.skip ? filterProps.skip + 1 : 1;
  let total = {
    all: 0,
    carbon_projects: 0,
    recommendations: 0,
    searched: 0,
    saved: 0,
  };
  try {
    // let totalsWithLocation: any;
    // let totalsWithoutLocation: any;
    // First, ensure we have the correct totals and pagination state
    if (currentPage === 1) {
      // Wait for the totals calculation to complete
      const totals = location
        ? await calculateTotalItems(filterProps, location)
        : await calculateTotalItems(filterProps);

      // Set initial pagination state based on calculated totals
      if (location) {
        const { totalLocation, aggregatedTotal, districtNoLocationTotal } = totals;
        if (totalLocation && aggregatedTotal && districtNoLocationTotal) {
          const paginationObject: RecommendationPagination = {
            aggregatedFinish: false,
            currentPageNumber: currentPage,
            skippedDistrict: 0,
            totalAggregated: aggregatedTotal,
            totalDistrict: districtNoLocationTotal,
            totalItems: totalLocation,
          };
          // totalsWithLocation = {
          //   aggregated: aggregatedTotal,
          //   districtTotal: districtNoLocationTotal,
          //   total: totalLocation,
          // };
          await dispatch(setRecommendationPagination(paginationObject));
        }
      } else {
        const { totalNoLocation, aggregatedTotal, districtAllTotal } = totals;
        if (totalNoLocation && aggregatedTotal && districtAllTotal) {
          const paginationObject: RecommendationPagination = {
            currentPageNumber: 1,
            aggregatedFinish: false,
            totalAggregated: aggregatedTotal,
            totalDistrict: districtAllTotal,
            totalItems: totalNoLocation,
            skippedDistrict: 0,
          };
          // totalsWithoutLocation = {
          //   aggregated: aggregatedTotal,
          //   districtTotal: districtAllTotal,
          //   total: totalNoLocation,
          // };
          await dispatch(setRecommendationPagination(paginationObject));
        }
      }
    }

    // Now proceed with fetching data based on the correct pagination state
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const aggregatedPages = Math.ceil(recommendationPagination.totalAggregated / ITEMS_PER_PAGE);
    const isLastAggregatedPage = currentPage === aggregatedPages;

    if (currentPage <= aggregatedPages) {
      // Fetch aggregated data
      const aggregatedResponse = await api.get(`/v2/recommendations/aggregation`, {
        params: {
          country_code: location ? location.id : 'ALL',
          skip: startIndex,
          limit: ITEMS_PER_PAGE,
          ...(filterProps.search && { search: filterProps.search }),
        },
      });

      const aggregatedItems = aggregatedResponse?.data?.items || [];
      aggregatedItems.forEach((item: any) => {
        item.aggregated = true;
      });
      recommendationProjectDataArray.push(...aggregatedItems);
      total = aggregatedResponse?.data?.total || total;

      // Handle last aggregated page if needed
      if (isLastAggregatedPage) {
        const remainingSlots = ITEMS_PER_PAGE - aggregatedItems.length;

        if (remainingSlots > 0) {
          const districtResponse = await api.get(`/v2/recommendations-by-districts/`, {
            params: {
              id: location ? location.id : 'ALL',
              level: location ? location.level : 0,
              search: filterProps.search || '',
              skip: 0,
              limit: remainingSlots,
            },
          });

          const districtItems = districtResponse?.data?.items || [];
          districtItems.forEach((item: any) => {
            item.aggregated = false;
          });
          recommendationProjectDataArray.push(...districtItems);
          total = districtResponse?.data?.total || total;

          // Update pagination state for transition to district-only data
          const paginationObject: RecommendationPagination = {
            ...recommendationPagination,
            aggregatedFinish: true,
            skippedDistrict: remainingSlots,
          };
          await dispatch(setRecommendationPagination(paginationObject));
        }
      }
    } else {
      // Fetch district-only data
      const districtSkip =
        recommendationPagination.skippedDistrict +
        (currentPage - aggregatedPages - 1) * ITEMS_PER_PAGE;

      const districtResponse = await api.get(`/v2/recommendations-by-districts/`, {
        params: {
          id: location ? location.id : 'ALL',
          level: location ? location.level : 0,
          search: filterProps.search || '',
          skip: districtSkip,
          limit: ITEMS_PER_PAGE,
        },
      });

      const districtItems = districtResponse?.data?.items || [];
      districtItems.forEach((item: any) => {
        item.aggregated = false;
      });
      recommendationProjectDataArray.push(...districtItems);
      total = districtResponse?.data?.total || total;
    }
    // Dispatch final results
    dispatch(
      loadProjectsSpecific.success({
        recommended: {
          items: recommendationProjectDataArray,
          total,
          pagination: {
            total: recommendationPagination.totalItems,
            page: currentPage,
            perPage: ITEMS_PER_PAGE,
          },
        },
      }),
    );

    return recommendationProjectDataArray;
  } catch (error) {
    console.error('Error fetching recommendations:', error);
    throw error;
  }
};

const calculateTotalItems = async (filterProps: any, location?: any) => {
  if (!location) {
    const aggregatedResponse = await api.get(
      `/v2/recommendations/aggregation?country_code=ALL&skip=${
        filterProps?.skip ? filterProps?.skip * 15 : 0
      }&limit=${filterProps?.limit}`,
    );
    // call district api
    const districtResponseALL = await api.get(
      `/v2/recommendations-by-districts/?id=ALL&level=0&search=${filterProps.search || ''}&skip=${
        filterProps?.skip ? filterProps?.skip * 15 : 0
      }&limit=${filterProps?.limit}`,
    );
    const aggregatedTotal = Number(aggregatedResponse?.data?.total?.searched);
    const districtAllTotal = Number(districtResponseALL?.data?.total?.searched);
    const totalNoLocation = aggregatedTotal + districtAllTotal;
    return { totalNoLocation, aggregatedTotal, districtAllTotal };
  } else {
    const aggregatedResponse = await api.get(
      `/v2/recommendations/aggregation?country_code=${location?.id}&skip=${
        filterProps?.skip ? filterProps?.skip * 15 : 0
      }&limit=${filterProps?.limit}`,
    );
    // call district api
    const districtResponse = await api.get(
      `/v2/recommendations-by-districts/?id=${location?.id}&level=${location.level}&search=${
        filterProps.search || ''
      }&skip=${filterProps?.skip ? filterProps?.skip * 15 : 0}&limit=${filterProps?.limit}`,
    );
    // const districtResponse = await api.get(
    //   `/v2/recommendations-by-districts/?id=${location?.id}&level=0&skip=${
    //     filterProps?.skip ? filterProps?.skip * 15 : 0
    //   }&limit=${filterProps?.limit}`,
    // );
    const aggregatedTotal = Number(aggregatedResponse?.data?.total?.searched);
    const districtNoLocationTotal = Number(districtResponse?.data?.total?.searched);
    const totalLocation = aggregatedTotal + districtNoLocationTotal;
    return { totalLocation, aggregatedTotal, districtNoLocationTotal };
  }
};

const fetchRecommendationProjects = async (suggestions: TSuggestions | null, params?: any) => {
  let body = {
    ...params,
  };
  try {
    if (suggestions && suggestions.suggestions.length) {
      const { id, level } = suggestions.suggestions[0];
      body = { ...body, id, level };
    }

    if (params && params.locations) {
      const coordinates = Object.values(params.locations).map((item: any) =>
        item.map(({ lat, lng }: any) => [`${lng}`, `${lat}`]),
      );
      body.coordinates = coordinates;
    }

    const response = await api.post(`/recommendations`, body).catch((error: any) => {
      if (error.response && error.response.status === 404) {
        dispatch(loadProjectsSpecific.fail('Nothing was found'));
        return;
      } else {
        console.error('Error in request:', error);
      }
      return null;
    });

    // const coordinatesArray: number[][] = [];
    const recommendationProjectDataArray: TRecommendation[] = [];

    if (response) {
      const { forest, mangroves } = response.data.items;
      recommendationProjectDataArray.push(...forest);
      recommendationProjectDataArray.push(...mangroves);

      dispatch(
        loadProjectsSpecific.success({
          recommended: {
            items: recommendationProjectDataArray,
            pagination: response.data.pagination || { total: 0 },
            total: response.data.total,
          } as any,
        }),
      );
    }

    return recommendationProjectDataArray;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(loadProjectsSpecific.fail('Results not found'));
      return;
    } else {
      console.error('Error in request:', error);
    }

    console.error('Error in searchSavedAsync:', error);
    throw error;
  }
};

const fetchSavedProjects = async () => {
  try {
    dispatch(loadProjectsSpecific.submit());

    const response = await api.get<FavoriteProjectsResponse>(`/user/favourites`);
    const favoriteProjectData: any[] = [];

    if (response) {
      const mangroveProjectsData = response.data.mangrove_projects;
      favoriteProjectData.push(...mangroveProjectsData);

      const carbonProjectsData = response.data.carbon_projects;
      favoriteProjectData.push(...carbonProjectsData);

      dispatch(
        loadProjectsSpecific.success({
          favorite: {
            items: favoriteProjectData,
            pagination: response.data.carbon_projects.length +
              response.data.mangrove_projects.length || { total: 0 },
          } as any,
        }),
      );
    }

    return favoriteProjectData;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(loadProjectsSpecific.fail('Results not found'));
      return;
    } else {
      console.error('Error in request:', error);
    }

    console.error('Error in favoriteProjectData:', error);
    throw error;
  }
};

export const searchAsync = async (prefix: string) => {
  try {
    const response = await api.get(`/search/${prefix}`);
    return response.data;
  } catch (error) {
    console.error('Error in searchAsync:', error);
  }
};

export const fetchUserLastLogin = async () => {
  try {
    const response = await api.get<PaginationResponse<AuditLog>>('/audit-log/');
    const lastLogin = convertDateString(response.data.data[0].timestamp);
    dispatch(changeUserAuditLogAction(lastLogin));
  } catch (error) {
    console.error('Error in request:', error);
  }
};

/**
 * Simplified fetch function for mangrove aggregations endpoint only
 */
export const fetchMangroveAggregations = async (
  location: { level: number; id: string; name: string } | null,
  filterProps: any,
) => {
  const ITEMS_PER_PAGE = 15;
  const recommendationProjectDataArray: TRecommendedProjectData[] = [];
  const currentPage = filterProps?.skip ? filterProps.skip + 1 : 1;
  let total = {
    all: 0,
    carbon_projects: 0,
    recommendations: 0,
    searched: 0,
    saved: 0,
  };

  try {
    const aggregatedResponse = await api.get(`/v2/recommendations/aggregation`, {
      params: {
        country_code: location ? location.id : 'ALL',
        skip: filterProps?.skip ? filterProps.skip * ITEMS_PER_PAGE : 0,
        limit: ITEMS_PER_PAGE,
        ...(filterProps.search && { search: filterProps.search }),
      },
    });

    const aggregatedItems = aggregatedResponse?.data?.items || [];
    aggregatedItems.forEach((item: any) => {
      item.aggregated = true;
    });
    recommendationProjectDataArray.push(...aggregatedItems);
    total = aggregatedResponse?.data?.total || total;

    dispatch(
      loadProjectsSpecific.success({
        recommended: {
          items: recommendationProjectDataArray,
          pagination: {
            total: total.searched,
            page: currentPage,
            perPage: ITEMS_PER_PAGE,
          },
          total,
        },
      }),
    );
  } catch (error) {
    console.error('Error fetching mangrove aggregations:', error);
    dispatch(loadProjectsSpecific.fail(error));
  }
};

/**
 * Simplified fetch function for mangrove districts endpoint only
 */
export const fetchMangroveDistricts = async (
  location: { level: number; id: string; name: string } | null,
  filterProps: any,
) => {
  const ITEMS_PER_PAGE = 15;
  const recommendationProjectDataArray: TRecommendedProjectData[] = [];
  const currentPage = filterProps?.skip ? filterProps.skip + 1 : 1;
  let total = {
    all: 0,
    carbon_projects: 0,
    recommendations: 0,
    searched: 0,
    saved: 0,
  };

  try {
    const districtResponse = await api.get(`/v2/recommendations-by-districts/`, {
      params: {
        id: location ? location.id : 'ALL',
        level: location ? location.level : 0,
        search: filterProps.search || '',
        skip: filterProps?.skip ? filterProps.skip * ITEMS_PER_PAGE : 0,
        limit: ITEMS_PER_PAGE,
      },
    });

    const districtItems = districtResponse?.data?.items || [];
    districtItems.forEach((item: any) => {
      item.aggregated = false;
    });
    recommendationProjectDataArray.push(...districtItems);
    total = districtResponse?.data?.total || total;

    dispatch(
      loadProjectsSpecific.success({
        recommended: {
          items: recommendationProjectDataArray,
          pagination: {
            total: total.searched,
            page: currentPage,
            perPage: ITEMS_PER_PAGE,
          },
          total,
        },
      }),
    );
  } catch (error) {
    console.error('Error fetching mangrove districts:', error);
    dispatch(loadProjectsSpecific.fail(error));
  }
};
